import {
  Color,
  MeshStandardMaterial,
  MeshMatcapMaterial,
  MeshBasicMaterial,
  sRGBEncoding,
  EquirectangularReflectionMapping,
  AdditiveBlending,
} from "three";

function handleMaterial(node) {
  let newMaterial = node.material;

  if (!newMaterial) return;

  if (
    newMaterial.name.includes("_standard") ||
    newMaterial.name.includes("_Standar")
  ) {
    return new MeshStandardMaterial({
      color: new Color(0xffffff),
      map: node.material.map,
      lightMap: node.material.emissiveMap,
      lightMapIntensity: 1,
      name: node.material.name,
    });
  }

  if (newMaterial.name.includes("_env")) {
    const texture = node.material.emissiveMap;

    texture.mapping = EquirectangularReflectionMapping;
    texture.encoding = sRGBEncoding;

    return new MeshBasicMaterial({
      color: node.material.color,
      map: node.material.map,
      reflectivity: 1,
      envMap: texture,
      name: node.material.name,
    });
  }

  if (newMaterial.name.includes("_matcap")) {
    return new MeshMatcapMaterial({
      color: node.material.color,
      matcap: node.material.emissiveMap,
      name: node.material.name,
    });
  }

  if (newMaterial.name.includes("_baked")) {
    return new MeshBasicMaterial({
      map: node.material.map,
      lightMapIntensity: 3,
      lightMap: node.material.emissiveMap,
      name: node.material.name,
    });
  }

  if (newMaterial.name.includes("_light")) {
    return new MeshBasicMaterial({
      map: node.material.map,
      blending: AdditiveBlending,
      //transparent: true,
      lightMapIntensity: 10,
      lightMap: node.material.emissiveMap,
      name: node.material.name,
    });
  }

  return new MeshStandardMaterial({
    color: new Color(0xffffff),
    map: node.material.map,
    name: node.material.name,
  });
}

export default handleMaterial;
